export default __webpack_public_path__ + "static/media/authorization-sider-sign-up-bg.b2bc7708.png";